import { render, staticRenderFns } from "./mynextpay-manual.vue?vue&type=template&id=72cba360&scoped=true"
import script from "./mynextpay-manual.vue?vue&type=script&lang=js"
export * from "./mynextpay-manual.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style_hdsd.css?vue&type=style&index=0&id=72cba360&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/bootstrap4.3.1.min.css?vue&type=style&index=1&id=72cba360&prod&scoped=true&lang=css&external"
import style2 from "./mynextpay-manual.vue?vue&type=style&index=2&id=72cba360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cba360",
  null
  
)

export default component.exports